import axios, { AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelTokenStatic } from 'axios';

import { GlobalConfiguration } from './GlobalConfiguration';

import { SecurityService } from '@/security/SecurityService';
import { Guid } from 'guid-typescript';

export class HttpClient {
    /**
     * Instance de la classe HttpClient.
     */
    private static instance: HttpClient = new HttpClient();

    /**
     * Client axios.
     */
    public axiosInstance: AxiosInstance;

    /**
     * Token pour l'annulation.
     */
    public cancelToken: CancelTokenStatic;

    /**
     * Configure le client axios de l'instance de HttpClient.
     * @returns true si la configuration a fonctionné, false sinon.
     */
    public static async init(): Promise<boolean> {
        try {
            // Configuration de l'URL d'API.
            this.instance.axiosInstance = axios.create({
                baseURL: GlobalConfiguration.apiUrl,
            });
            this.instance.cancelToken = axios.CancelToken;

            // Récupération de l'utilisateur connecté depuis le localStorage.
            // Si l'utilisateur est déjà connecté, on configure son acces_token pour les requêtes.
              // Si l'utilisateur est déjà connecté, on configure son acces_token pour les requêtes.
            if (await SecurityService.isAuthenticated()) {
                this.setAuthorizationHeaders();
            }

            this.configureInterceptorRequete()

            // Configuration des intercepteurs de réponses.
            this.configureInterceptorReponse()

            return true;
        } catch (err) {
            return false;
        }
    }


        /**
     * Configuration des intercepteurs de requêtes.
     */
    public static configureInterceptorRequete():
        | AxiosRequestConfig
        | Promise<never>
        | void {
             // Configuration des intercepteurs de requêtes.
            this.instance.axiosInstance.interceptors.request.use(
                function (config) {
                    config.headers['X-Correlation-ID'] =
                        Guid.create().toString();
                    return config;
                },
                function (error) {
                    // Do something with request error
                    return Promise.reject(error);
                }
            );
    }

            /**
     * Configuration des intercepteurs de réponses.
     */
    public static configureInterceptorReponse():
        | Promise<AxiosResponse<unknown>>
        | AxiosResponse<unknown>
        | void {
   this.instance.axiosInstance.interceptors.response.use(
                function (response) {
                    // Do something with response data
                    return response;
                },
                async function (error) {
                    // Check if the error is a cancellation and suppress it
                    if (
                        axios.isCancel(error) ||
                        error.code === 'ERR_CANCELED'
                    ) {
                        return Promise.resolve();
                    }
                    // Si l'authent du Back office a expiré et qu'on était toujours connecté dans le front, on refresh
                    if (
                        error.response &&
                        error.response.status === 401 &&
                        (await SecurityService.isAuthenticated())
                    ) {
                        SecurityService.logout();
                    }

                    return Promise.reject(error);
                }
            );
    }

    
    /**
     * Getter de l'instance HttpClient
     */
    public static get Instance(): HttpClient {
        return this.instance || (this.instance = new this());
    }

    /**
     * Getter du client axios de l'instance HttpClient
     */
    public static get axios() {
        return this.Instance.axiosInstance;
    }

    /**
     * Getter pour l'annulation des requête.
     */
    public static get cancelToken() {
        return this.Instance.cancelToken;
    }

    /**
     * Configure le client axios pour envoyer le token utilisateur dans les headers de requêtes vers l'API.
     */
    public static async setAuthorizationHeaders() {
        this.instance.axiosInstance.defaults.headers.common[
            'Authorization'
        ] = `Bearer ${await SecurityService.getAccessToken()}`;
    }

    /**
     * Supprime le token du header.
     * */
    public static logout() {
        this.instance.axiosInstance.defaults.headers.common['Authorization'] =
            '';
    }
}
